import { ReactNode } from "react";

const API_DOWN_MESSAGE = (
  <>
    There may be an issue with your network or our services. <a href="https://status.connectel.app/en">Status for connectel.app</a>
  </>
);

export const formatError = (error: Error): { title: ReactNode; description?: ReactNode } => {
  if (error.message == "Failed to fetch")
    return { title: "Unable to make request", description: API_DOWN_MESSAGE };

  return { title: error.message ?? "-" };
};
